angular.module('jv.Dashboard.Todo.Tasks.Controller', [])
    .controller('jv.Dashboard.Todo.Tasks.Controller', ['$scope', 'jvDashboardAjaxService', '$window', 'jvContextualLoadingService', '$q', '$rootScope', '$timeout', '$jobviteUrls','jvHireUrlService',
        function($scope, jvDashboardAjaxService, $window, jvContextualLoadingService, $q, $rootScope, $timeout, $jobviteUrls, jvHireUrlService) {
            $scope.refreshTimestamp = true;
            //Handler for refresh_widget
            $rootScope.$on('REFRESH_WIDGET', function(event, widgetData) {
                if (widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)) {
                    $scope.fetchTasksAndRender();
                    $scope.refreshTimestamp = false;
                }
            });
            $scope.jvUrls = $jobviteUrls;
            $scope.requestObject = {
                'action': 'list',
                'output': 'json',
                'type': '1',
                'sortBy': 'dueDate',
                'overdue': false,
                'page': 0,
                'pageSize': 5,
                'ownerEId': $window._jvselfUser.eid,
                'ownerUserIds': $window._jvselfUser.eid,
                'previousDays': 7,
                'endDays': 7
            };
            $scope.taskCompleted = {};
            //type=1 open type=2 is completed  overdue = true/false
            var fetchTasks = function() {
                jvContextualLoadingService.show($scope.widgetObject.widgetId);
                var deferred = $q.defer();
                var widgetSettings = $scope.widgetObject.userWidgetSettings.widgetSetting;

                angular.forEach(widgetSettings, function(widgetSetting, index) {
                    var settingObject;
                    if (widgetSetting.userValues) {
                        settingObject = widgetSetting.userValues[0];
                    } else {
                        if (widgetSetting.settings.defaultValues) {
                            settingObject = widgetSetting.settings.defaultValues[0];
                        }
                        //settingObject = widgetSetting.settings.defaultValues[0];
                    }
                    switch (widgetSetting.settings.name) {
                        case "FilterBy":
                            if (settingObject.name === 'DASHBOARD.WIDGET.SETTINGS.VALUE.OVERDUE') {
                                $scope.requestObject.overdue = settingObject.value;
                            } else {
                                $scope.requestObject.overdue = false;
                                $scope.requestObject.type = settingObject.value;
                            }
                            break;
                        case "TaskType":
                            if (settingObject) {
                                $scope.requestObject.entityType = settingObject.value;
                            }
                            break;
                        default:
                            break;
                    }
                });
                jvDashboardAjaxService.getTasks($scope.requestObject, function(response) {
                    $scope.refreshTimestamp = true;
                    if (response) {
                        if (!response.resultList.length && $scope.requestObject.page > 0) {
                            //Complete all tasks on a page then it should go back to previous page.
                            $scope.requestObject.page--;
                            $scope.fetchTasksAndRender();
                        } else {
                            deferred.resolve(response);
                        }
                    }
                });
                return deferred.promise;
            };

            $scope.fetchTasksAndRender = function() {
                fetchTasks().then(function(response) {
                    $scope.pageCount = 5;
                    if ($scope.requestObject.page === 0 || !$scope.requestObject.page) {
                        $scope.disablePrev = true;
                    } else {
                        $scope.disablePrev = false;
                    }
                    if ((($scope.requestObject.page + 1) * $scope.pageCount >= response.resultCount) || (!response.resultCount)) {
                        $scope.disableNext = true;
                    } else {
                        $scope.disableNext = false;
                    }
                    jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                    renderData(response);
                });
            };
            $scope.fetchTasksAndRender();

            var renderData = function(data) {
                if (data) {
                    $scope.tasks = data.resultList;
                    $scope.resultCount = data.resultCount;
                    //Uncomment once we fix the backend
                    //$scope.pageCount = response.pageCount;

                }
            };

            //Used to paginate
            $scope.paginate = function(direction) {
                jvContextualLoadingService.show($scope.widgetObject.widgetId);
                $scope.requestObject.page = (direction === 'next') ? ($scope.requestObject.page + 1) : ($scope.requestObject.page - 1);
                if (($scope.requestObject.page < 0)) {
                    $scope.requestObject.page = 0;
                    return false;
                }

                if ($scope.requestObject.page >= Math.ceil($scope.resultCount / $scope.requestObject.pageSize)) {
                    $scope.requestObject.page = Math.ceil($scope.resultCount / $scope.requestObject.pageSize) - 1;
                    return false;
                }
                $scope.fetchTasksAndRender();
            };

            $scope.taskEntityUrl = function(task) {
                switch (task.entityType) {
                    case "Contact":
                        return $window.jvUrls.source + '/person/contactDetails.html?ids=' + task.entityEId;
                    case "Application":
                        return jvHireUrlService.getApplicationDetailsUrlWithTab(task.entityEId,false,'summary/{0}'.format(task.entityEId));
                    default:
                        break;
                }
            };

            $scope.getTaskDateInMilliseconds = function(task) {
                return $rootScope.getMilliseconds(task.dueDate);
            };

            $scope.taskPastDue = function(task) {
                return ($scope.getTaskDateInMilliseconds(task) < $rootScope.getTodayDateUserTimezone());
            };

            $scope.completeTask = function(task, index) {
                $scope.taskCompleted[index] = false;
                jvDashboardAjaxService.completeTask({
                    'id': task.SId
                }, function(response) {
                    $scope.tasks.splice(index, 1);
                    //Add logic to show confirmation 
                    $scope.fetchTasksAndRender();
                });
            };
        }
    ]);